/** Кг в строке заявки — в одной точности с product_containers.weight (NUMERIC 14,3) */
export const DEAL_LINE_KG_DECIMALS = 3;

const DEAL_LINE_KG_SCALE = Math.pow(10, DEAL_LINE_KG_DECIMALS);

const LOG_FIX =
  (process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test") ||
  process.env.LOG_LEVEL === "debug" ||
  !!process.env.DEBUG_FIX;

/**
 * Количество тар: ceil(кг / вес тары) в целых тысячных кг,
 * чтобы 168 / 5.6 давало 30, а не 31 из-за float.
 */
export function ceilContainersFromKg(
  kg: number | null,
  tareWeight: number | null,
): number {
  if (LOG_FIX) {
    console.log("[FIX] ceilContainersFromKg input", { kg, tareWeight });
  }

  try {
    if (
      kg == null ||
      tareWeight == null ||
      !Number.isFinite(kg) ||
      !Number.isFinite(tareWeight) ||
      tareWeight <= 0
    ) {
      if (LOG_FIX) {
        console.log("[FIX] ceilContainersFromKg fallback", {
          kg,
          tareWeight,
          containers: 1,
        });
      }
      return 1;
    }

    const kgScaled = Math.round(kg * DEAL_LINE_KG_SCALE);
    const tareScaled = Math.round(tareWeight * DEAL_LINE_KG_SCALE);
    const containers = Math.ceil(kgScaled / tareScaled) || 1;

    if (LOG_FIX) {
      console.log("[FIX] ceilContainersFromKg success", {
        kg,
        tareWeight,
        kgScaled,
        tareScaled,
        containers,
      });
    }

    return containers;
  } catch (error) {
    const err = error as Error;
    console.error("[FIX] ceilContainersFromKg error", {
      kg,
      tareWeight,
      error: err && err.message,
      stack: err && err.stack,
    });
    throw error;
  }
}
